import React from "react";
import "antd/dist/antd.css";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import newLogo from "../Images/bg_transparent.png";
import {
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  Button,
  Modal,
  Popover,
  InputNumber,
  message,
  notification,
} from "antd";
import { doRegistration } from "../api/RegistrationsApis";
import { getUserProfile } from "../api/userProfile";
import Amplify, { Auth } from "aws-amplify";
import AppConfig from "../Config/AppConfig";
import { withAppContext } from "../store/contextStore";
import LocationAutocomplete from "./Autocomplete";
import { getDetails } from "../api/Apis";
import NumberFormat from "react-number-format";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../utils/Utils";
Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: `${AppConfig.APP_IDENTITY_POOL_ID}`,
    // REQUIRED - Amazon Cognito Region
    region: `${AppConfig.APP_COGNITO_REGION}`,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: `${AppConfig.APP_COGNITO_USER_POOL_ID}`,
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: `${AppConfig.APP_CLIENT_ID}`,
  },
});

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      companyname: "",
      address: "",
      email: "",
      phonenumber: "",
      password: "",
      city: "",
      state: "",
      zip: "",
      latLangs: "",
      confirmpassword: "",
      loading: false,
      confirmDirty: false,
      autoCompleteResult: [],
      visible: false,
      agreement: "",
      emailData: "",
      passwordData: "",
      codeData: "",
    };
  }
  componentDidMount = () => {
    let urlData = this.props.location.search;
    let Data = urlData.split(",");
    this.setState({
      firstName: Data[0],
      lastName: Data[1],
      email: Data[2],
      companyName: Data[3],
      phone: Data[4],
    });
  };

  hasErrors = (fieldsError) =>
    Object.keys(fieldsError).some((field) => fieldsError[field]);
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({
        agreement: values.agreement,
      });
      if (!err) {
        let registrationType = "carrier";
        let userProfile = "CA";
        if (this.props.registrationType === "customer") {
          registrationType = this.props.registrationType;
          userProfile = "CU";
        }
        if (this.props.registrationType === "driver") {
          registrationType = this.props.registrationType;
          userProfile = "D";
        }
        console.log("no errors");
        if (values["phone"].toString().length < 10) {
          message.error("Please enter valid phone number");
          return;
        }
        let lowerEmail = values["email"].toLowerCase();
        let data = {
          firstName: values["firstName"],
          lastName: values["lastName"],
          companyName: values["companyName"],
          address: values["address"],
          city: null,
          stateText: null,
          zip: null,
          phone: values["phone"].toString(),
          email: lowerEmail,
          userProfile: userProfile,
          registrationType: registrationType,
          mc: values["mc"] ? values["mc"] : null,
          dot: values["dot"] ? values["dot"] : null,
        };
        this.addUser(values["email"], values["password"], data);
      }
    });
  };

  addUser = async (email, password, regData) => {
    this.setState({ loading: true });
    await Auth.signUp({
      username: email,
      password: password,
    })
      .then((data) => {
        regData["userId"] = data.userSub;
        this.saveRegistrationData(regData);
      })
      .catch((err) => {
        if (err.code === "InvalidPasswordException") {
          alert(
            "Invalid Password: \n- Minimum password length:6\n- Require at least one uppercase letter\n- Require at least one lowercase letter\n- Require at least one number\n- Require at least one nonalphanumeric character"
          );
          this.setState({ value: true, loading: false });
        } else {
          alert(err.message);
          this.setState({ value: true, loading: false });
        }
      });
  };

  saveRegistrationData = async (regData) => {
    const data = {
      entityData: regData,
    };
    doRegistration(data).then((result) => {
      if (result.success) {
        if (regData.userProfile === "D") {
          message.success(
            "Driver registration Done Successfully Please login with email and password"
          );
        } else if (regData.userProfile === "CU") {
          message.success(
            "Customer registration Done Successfully Please login with email and password"
          );
        } else {
          message.success(
            "Carrier registration Done Successfully Please login with email and password"
          );
        }
        this.props.history.push("/login");
        // this.doLogin(email, password);
      } else {
        console.log(result.errors);
        this.setState({ loading: false });
      }
    });
  };

  onFinish = async () => {
    this.setState({
      loading: true,
    });
    try {
      await Auth.confirmSignUp(this.state.emailData, this.state.codeData).then(
        async (result) => {
          console.log(result, "result");
          this.doLogin(this.state.emailData, this.state.passwordData);
        }
      );
    } catch (error) {
      this.setState({
        loading: false,
      });
      message.error("Invalid Confirm Code");
    }
  };

  handleResendConfirmCode = async () => {
    console.log("check");
    try {
      await Auth.resendSignUp(this.state.emailData);
      notification["success"]({
        message: "code resent successfully",
      });
    } catch (err) {
      console.log("error resending code: ", err);
      notification["error"]({
        message: "error resending code.",
      });
    }
  };

  doLogin = async (email, password) => {
    try {
      this.setState({
        loading: false,
      });
      const user = await Auth.signIn(email, password);
      const userDetails = Object.assign(
        {},
        {
          token: user.signInUserSession.idToken.jwtToken,
          userid: user.username,
        }
      );
      // this.props.context.setUser(userDetails, false);
      this.getProfile(userDetails.userid);
    } catch (err) {
      if (err.code === "UserNotConfirmedException") {
        this.setState({
          showModal: true,
          emailData: email,
          passwordData: password,
        });
      } else if (err.code === "PasswordResetRequiredException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else if (err.code === "NotAuthorizedException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else if (err.code === "UserNotFoundException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else {
        this.setState({
          loading: false,
          errors: err.message,
        });
      }
    }
  };

  getProfile = (id) => {
    this.setState({
      loading: true,
    });
    console.log(id);
    getUserProfile(id).then((result) => {
      if (result.success) {
        this.setState({
          loading: false,
        });
        localStorage.setItem("orgId", result.data.orgId);
        localStorage.setItem("userDetails", JSON.stringify(result.data));
        // this.props.context.setUserDetails(result.data);
        getDetails(
          AppConfig["entityNames"]["registrations"],
          result.data.orgId
        ).then((regResult) => {
          if (regResult.success) {
            localStorage.setItem("orgDetails", JSON.stringify(regResult.data));
            if (result.data.userProfile === "CA") {
              this.props.history.push("/carrier_app/documentation");
            } else if (result.data.userProfile === "CU") {
              this.props.history.push("/app/customerdocumentation");
            }
          } else {
            this.setState({
              loading: false,
              errors: regResult.errors,
            });
          }
        });
      } else {
        this.setState({
          loading: false,
          errors: result.errors,
        });
      }
    });
  };

  confirmUser = async (email, password, code) => {
    try {
      await Auth.confirmSignUp(email, code).then(async (result) => {
        if (result === "SUCCESS") {
          await this.doLogin(email, password);
        }
      });
    } catch (error) {
      alert("Invalid code");
      var newCode = prompt("Please enter the code which is sent to your mail");
      if (newCode !== "") {
        this.confirmUser(email, password, newCode);
      }
    }
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("password")) {
      // callback('Two passwords that you enter is inconsistent!');
      callback("Both passwords are not matching.");
    } else {
      callback();
    }
  };
  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  getAddress = (address, latLng, id) => {
    this.props.form.setFieldsValue({
      [id]: address,
    });
    let latLangs = this.state.latLangs;
    this.setState({
      latLangs,
    });
  };

  setPhoneNumber = (value, id) => {
    this.props.form.setFieldsValue({
      [id]: value,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    let registrationType = "carrier";
    if (this.props.registrationType) {
      registrationType = this.props.registrationType;
    }

    let passwordCriteria = (
      <div>
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            -Minimum password length: 6 <br />
            -Required at least one uppercase letter
            <br />
            -Required at least one lowercase letter
            <br />
            -Required at least one number
            <br />
            -Required at least one nonalphanumeric character
            <br />
          </Col>
        </Row>
      </div>
    );
    return (
      <>
        <Form onSubmit={this.handleSubmit} style={{ marginBottom: "10%" }}>
          <Col span={24}>
            <Row>
              <Col span={24}>
                <div style={{ textAlign: "center" }}>
                  <img src={newLogo} alt="Logo" style={{ width: "160px" }} />
                </div>
              </Col>
            </Row>
          </Col>
          <Row>
            <h2 className="Login">
              {this.props.registrationType === "customer"
                ? "Create A New Customer Account"
                : this.props.registrationType === "driver"
                ? "Create A New Driver Account"
                : "Create A New Carrier Account"}
            </h2>
            <p className="carrier1">
              We are growing our community daily with lots of happy customers.
            </p>
          </Row>
          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                className="Formitem"
                label={<span className="label">First Name</span>}
              >
                {getFieldDecorator("firstName", {
                  rules: [
                    {
                      required: true,
                      message: "Please input your First Name!",
                    },
                    noWhitespaceRule,
                  ],
                })(<Input placeholder="First name" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                className="Formitem"
                label={<span className="label">Last Name</span>}
              >
                {getFieldDecorator("lastName", {
                  rules: [
                    { required: true, message: "Please input your Last Name!" },
                    noWhitespaceRule,
                  ],
                })(<Input placeholder="Last name" />)}
              </Form.Item>
            </Col>
          </Row>
          {registrationType !== "driver" && (
            <Row>
              <Col>
                <Form.Item
                  className="Formitem"
                  label={<span className="label">Company Name</span>}
                >
                  {getFieldDecorator("companyName", {
                    rules: [
                      {
                        required: true,
                        message: "Please input your Company Name!",
                      },
                      noWhitespaceRule,
                    ],
                    initialValue: this.state.companyName,
                  })(<Input placeholder="Company name" />)}
                </Form.Item>
              </Col>
            </Row>
          )}
          {registrationType === "carrier" && (
            <Row gutter={10}>
              <Col span={12}>
                <Form.Item
                  className="Formitem"
                  label={<span className="label">MC#</span>}
                >
                  {getFieldDecorator("mc", {
                    rules: [
                      { required: true, message: "Please input MC number" },
                      noWhitespaceRule,
                    ],
                  })(<Input placeholder="MC#" style={{ width: "100%" }} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="Formitem"
                  label={<span className="label">DOT#</span>}
                >
                  {getFieldDecorator("dot", {
                    rules: [
                      { required: true, message: "Please input DOT number" },
                      noWhitespaceRule,
                    ],
                  })(<Input placeholder="DOT#" />)}
                </Form.Item>
              </Col>
            </Row>
          )}
          {registrationType !== "driver" && (
            <Row gutter={10}>
              <Col span={24}>
                <Form.Item
                  className="Formitem"
                  label={<span className="label">Address</span>}
                >
                  {getFieldDecorator("address", {
                    rules: [
                      { required: true, message: "Please input your Address!" },
                    ],
                  })(
                    <LocationAutocomplete
                      getAddress={(address, latLng) =>
                        this.getAddress(address, latLng, "address")
                      }
                      editMode={false}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          )}

          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                className="Formitem"
                label={<span className="label">Contact Phone</span>}
              >
                {getFieldDecorator("phone", {
                  rules: [
                    {
                      required: true,
                      message: "Please input your contact phone!",
                    },
                    noWhitespaceRule,
                    notValidPhoneNumberRule,
                  ],
                })(
                  <Input
                    placeholder="(754)581-3996"
                    style={{ width: "100%" }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                className="Formitem"
                label={<span className="label">Corporate Email</span>}
              >
                {getFieldDecorator("email", {
                  rules: [
                    {
                      type: "email",
                      message: "The input is not valid Corporate Email",
                    },
                    {
                      required: true,
                      message: "Please input your Corporate Email!",
                    },
                  ],
                })(
                  <Input
                    placeholder="mary.vargas@mail.com"
                    autoComplete="new-password"
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                className="Formitem"
                label={<span className="label">Password</span>}
              >
                {getFieldDecorator("password", {
                  rules: [
                    { required: true, message: "Please input your password!" },
                    noWhitespaceRule,
                    { validator: this.validateToNextPassword },
                  ],
                })(
                  <Input.Password
                    placeholder="*********"
                    autoComplete="new-password"
                  />
                )}
              </Form.Item>
              <Popover
                placement="top"
                title={
                  <h2 style={{ textAlign: "center" }}>Password Criteria</h2>
                }
                content={passwordCriteria}
                trigger="hover"
              >
                <span style={{ color: "#20a8d8" }}>Criteria</span>
              </Popover>
            </Col>
            <Col span={12}>
              <Form.Item
                className="Formitem"
                label={<span className="label">Confirm Password</span>}
              >
                {getFieldDecorator("confirm", {
                  rules: [
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    noWhitespaceRule,
                    { validator: this.compareToFirstPassword },
                  ],
                })(
                  <Input.Password
                    placeholder="*********"
                    onBlur={this.handleConfirmBlur}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="terms">
            {getFieldDecorator("agreement", {
              rules: [
                {
                  required: true,
                  message:
                    "Please agree to our terms and conditions before you proceed!",
                },
              ],
              valuePropName: "checked",
            })(
              <div>
                <Checkbox>I agree with the</Checkbox>
                <span
                  style={{
                    color: "#1890ff",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={this.showModal}
                >
                  Terms and Conditions
                </span>
              </div>
            )}
          </Form.Item>
          <Form.Item className="signupbutton">
            <Button
              type="primary"
              loading={this.state.loading}
              htmlType="submit"
              className="Submit"
            >
              Create Account
            </Button>
          </Form.Item>
          <div className="footer">
            <p>
              Already have an Account?{" "}
              <Link to="/login" className="Loginclick">
                Click Here to Login
              </Link>
            </p>
          </div>

          <Modal
            title="Terms & Conditions"
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            className="terms_conModal"
          >
            <p style={{ fontWeight: "bold" }}>1. Terms</p>
            <p>
              By accessing this Website, accessible from bulkmaterialpro.com,
              you are agreeing to be bound by these Website Terms and Conditions
              of Use and agree that you are responsible for the agreement with
              any applicable local laws. If you disagree with any of these
              terms, you are prohibited from accessing this site. The materials
              contained in this Website are protected by copyright and trade
              mark law.
            </p>

            <p style={{ fontWeight: "bold" }}>2. Use License</p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Bulk Material Pro’sWebsite for personal,
              non-commercial transitory viewing only. This is the grant of a
              license, not a transfer of title, and under this license you may
              not:
            </p>
            <p>
              modify or copy the materials; <br />
              use the materials for any commercial purpose or for any public
              display; <br />
              attempt to reverse engineer any software contained on Bulk
              Material Pro’sWebsite; <br />
              remove any copyright or other proprietary notations from the
              materials; or <br />
              transferring the materials to another person or "mirror" the
              materials on any other server. <br />
              This will let Bulk Material Pro’sto terminate upon violations of
              any of these restrictions. Upon termination, your viewing right
              will also be terminated and you should destroy any downloaded
              materials in your possession whether it is printed or electronic
              format.
            </p>

            <p style={{ fontWeight: "bold" }}>3. Disclaimer</p>
            <p>
              All the materials on Bulk Material Pro’sWebsite are provided “as
              is”. Bulk Material Promakes no warranties, may it be expressed or
              implied, therefore negates all other warranties. Furthermore, Bulk
              Material Prodoes not make any representations concerning the
              accuracy or reliability of the use of the materials on its Website
              or otherwise relating to such materials or any sites linked to
              this Website.
            </p>

            <p style={{ fontWeight: "bold" }}>4. Limitations</p>
            <p>
              Bulk Material Proor its suppliers will not be hold accountable for
              any damages that will arise with the use or inability to use the
              materials on Bulk Material Pro's Website, even if Bulk Material
              Proor an authorize representative of this Website has been
              notified, orally or written, of the possibility of such damage.
              Some jurisdiction does not allow limitations on implied warranties
              or limitations of liability for incidental damages, these
              limitations may not apply to you.
            </p>

            <p style={{ fontWeight: "bold" }}>5. Revisions and Errata</p>
            <p>
              The materials appearing on Bulk Material Pro’s Website may include
              technical, typographical, or photographic errors. Bulk Material
              Prowill not promise that any of the materials in this Website are
              accurate, complete, or current. Bulk Material Promay change the
              materials contained on its Website at any time without notice.
              Bulk Material Prodoes not make any commitment to update the
              materials.
            </p>

            <p style={{ fontWeight: "bold" }}>6. Links</p>
            <p>
              Bulk Material Prohas not reviewed all of the sites linked to its
              Website and is not responsible for the contents of any such linked
              site. The presence of any link does not imply endorsement by Bulk
              Material Proof the site. The use of any linked website is at the
              user'sown risk.
            </p>

            <p style={{ fontWeight: "bold" }}>
              7. Site Terms of Use Modifications
            </p>
            <p>
              Bulk Material Promay revise these Terms of Use for its Website at
              any time without prior notice. By using this Website, you are
              agreeing to be bound by the current version of these Terms and
              Conditions of Use.
            </p>

            <p style={{ fontWeight: "bold" }}>8.Governing Law</p>
            <p>
              Any claim related to Bulk Material Pro’s Website shall be governed
              by the laws of Country without regards to its conflict of law
              provisions.
            </p>
          </Modal>
        </Form>
        <Modal
          visible={this.state.showModal}
          title={
            <p
              className="font-family-style font-medium-size"
              style={{ color: "blue", margin: "0px" }}
            >
              Confirm SignUp
            </p>
          }
          onCancel={() => {
            this.setState({ showModal: false });
          }}
          maskClosable={false}
          className="modal-black-close"
          footer={false}
        >
          <div style={{ padding: "5px 10px" }}>
            <span className="font-family-style text-size padding register-confirm">
              We have sent you a confirmation code to your email. Please enter
              the code below to complete your signup. Thank you.
            </span>
          </div>
          <Form
            className="padding font-family-style text-size"
            style={{ padding: "5px 10px" }}
          >
            <NumberFormat
              className="ant-input-number"
              placeholder="Please input the code."
              maxLength="6"
              onChange={(e) => {
                this.setState({ codeData: e.target.value });
              }}
              style={{
                height: "40px",
                marginBottom: "1vw",
                width: "100%",
                padding: "5px 10px",
              }}
            />
            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                onClick={this.onFinish}
                loading={this.state.loading}
                style={{ height: "40px", marginBottom: "1vw" }}
              >
                <span className="align">Submit</span>
              </Button>
              <Button
                type="primary"
                htmlType="reset"
                onClick={this.handleResendConfirmCode}
                style={{
                  height: "40px",
                  marginLeft: "1vw",
                  background: "#ff6c5e",
                  border: "1px solid #ff6c5e",
                }}
              >
                <span className="align">Resend</span>
              </Button>
            </div>
          </Form>
        </Modal>
      </>
    );
  }
}

export default Form.create({ name: "register" })(
  withAppContext(withRouter(RegistrationForm))
);
